module.exports = __webpack_public_path__ + "img/Cabal.be5f4d61.jpg";